import React, { useState, useRef, useEffect } from "react";
import "./navbarComponent.scss";
import LogoImg from "../../assets/icons/cubeGlobalLogo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { CgMenuRight } from "react-icons/cg";
import ContactMethod from "./contactMethodComponent";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdPhoneIphone } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <>
      <div className="navbar-container">
        <img src={LogoImg} alt="Logo" />
        <NavigationButtons />

        {isMenuOpen ? (
          <IoCloseOutline className="menu-icon" onClick={toggleMenu} />
        ) : (
          <CgMenuRight className="menu-icon" onClick={toggleMenu} />
        )}
      </div>

      <ResponsiveNavButtons isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen} />
    </>
  );
};

const NavigationButtons = () => {
  const [servicesMenuOpen, setServicesMenuOpen] = useState(false);
  const servicesMenuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (servicesMenuRef.current && !servicesMenuRef.current.contains(event.target)) {
        setServicesMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [servicesMenuRef]);

  return (
    <div className={`nav-links-container`}>
      <NavLink to="/home" activeClassName="active">
        Home
      </NavLink>
      <NavLink to="/about-us" activeClassName="active">
        About Us
      </NavLink>
      <NavLink to="/our-mission" activeClassName="active">
        Our Mission
      </NavLink>
      <NavLink to="/services" className='services-menu' activeClassName="active" ref={servicesMenuRef} onMouseOver={() => setServicesMenuOpen(true)} onMouseOut={() => setServicesMenuOpen(false)}>
        Services
        {/* <OutlineCaret onClick={() => setServicesMenuOpen(!servicesMenuOpen)} /> */}
        {
          servicesMenuOpen && (
            <div className='services-list'>
              <div
                className="dropdown-option"
              >
                <NavLink to="/software-development" activeClassName="active">
                  Software Development
                </NavLink>
              </div>

              <div
                className="dropdown-option"
              >
                <NavLink to="/tehnology-management" activeClassName="active">
                  Technology Development
                </NavLink>
              </div>
              <div
                className="dropdown-option"
              >
                <NavLink to="/corporate-management" activeClassName="active">
                  Corporate Management
                </NavLink>
              </div>
              <div
                className="dropdown-option"
              >
                <NavLink to="/consulting" activeClassName="active">
                  Consulting
                </NavLink>
              </div>
            </div>
          )
        }
      </NavLink>
      {/* <NavLink to="/testimonials" activeClassName="active">
        Testimonials
      </NavLink> */}
      <div className="contact-us-container">
      <NavLink to="/contact-us" activeClassName="active">
        Contact Us
      </NavLink>
      </div>
    </div>
  );
};

const ResponsiveNavButtons = ({ isMenuOpen, setMenuOpen }) => {


  return (
    <div
      className={`hidden-navlinks-container ${isMenuOpen ? "open" : "close"}`}
    >
      <NavLink to="/home" onClick={() => setMenuOpen(false)} activeClassName="active">
        Home
      </NavLink>
      <NavLink to="/about-us" onClick={() => setMenuOpen(false)} activeClassName="active">
        About Us
      </NavLink>
      <NavLink to="/our-mission" onClick={() => setMenuOpen(false)} activeClassName="active">
        Why choose us
      </NavLink>
      <NavLink to="/services" onClick={() => setMenuOpen(false)} activeClassName="active">
        Services
      </NavLink>
      <NavLink to="/software-development" onClick={() => setMenuOpen(false)} activeClassName="active">
        Development
      </NavLink>
      <NavLink to="/tehnology-management" onClick={() => setMenuOpen(false)} activeClassName="active">
        Tehnology
      </NavLink>
      <NavLink to="/corporate-management" onClick={() => setMenuOpen(false)} activeClassName="active">
        Corporate
      </NavLink>
      <NavLink to="/consulting" onClick={() => setMenuOpen(false)} activeClassName="active">
        Consulting
      </NavLink>
      {/* <NavLink to="/testimonials" onClick={() => setMenuOpen(false)} activeClassName="active">
        Testimonials
      </NavLink> */}
      <NavLink to="/contact-us" onClick={() => setMenuOpen(false)} activeClassName="active">
        Contact Us
      </NavLink>

      <ContactMethod
        icon={FaMapMarkerAlt}
        text={
          "Arthur Evelyn Building, Suite 5, Main Street, Charlestown, Nevis"
        }
      />
      <ContactMethod icon={MdPhoneIphone} text={"+381-60-3335726"} />
    </div>
  );
};

export default Navbar;
